module.exports = __webpack_public_path__ + "assets/img/idea.85135234.png";